import styled from 'styled-components';

import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $ClickableCard = styled.button<{
  $isFluid?: boolean;
  $isGrabbed?: boolean;
  $shouldDisplayHoverStatus?: boolean;
  $isActive?: boolean;
  $isDisabled?: boolean;
  $isNaked?: boolean;
  $hasPadding?: boolean;
}>`
  color: ${({ theme }) => theme.colors.mainTextColor};
  margin: 0;
  border: none;
  background: none;
  font: inherit;
  cursor: ${({ draggable }) => (draggable ? 'grab' : 'pointer')};
  outline: inherit;
  transition:
    border-color 0.2s ease-in,
    color 0.2s ease-in;

  width: ${({ $isFluid }) => ($isFluid ? '100%' : undefined)};
  padding: ${({ $hasPadding }) => ($hasPadding ? spacing('lg') : '0')};
  border-radius: ${spacing('sm')};
  border: 1px solid
    ${({ theme, $isActive, $isDisabled, $isNaked }) => {
      if ($isNaked) {
        return 'transparent';
      }

      if ($isDisabled) {
        return theme.colors.disabled;
      }

      if ($isActive) {
        return theme.colors.primary;
      }

      return theme.colors.disabled;
    }};

  opacity: ${({ $isGrabbed }) => ($isGrabbed ? ' 0.5' : '1')};
  cursor: ${({ $isGrabbed, $isDisabled }) => {
    if ($isDisabled) {
      return '';
    }

    if ($isGrabbed) {
      return 'grab';
    }
  }};

  background-color: ${({ theme, $isDisabled }) => {
    if ($isDisabled) {
      return theme.colors.disabled;
    }

    return theme.systemColors.defaultBackground;
  }};
  display: flex;
  justify-content: space-between;

  &:hover {
    border: 1px solid
      ${({ theme, $shouldDisplayHoverStatus, $isActive, $isDisabled }) => {
        if ($isDisabled) {
          return 'unset';
        }

        if ($shouldDisplayHoverStatus) {
          if ($isActive) {
            return theme.newUI.variationColors.light2;
          } else {
            return theme.newUI.variationColors.dark1;
          }
        } else {
          return theme.colors.disabled;
        }
      }};

    background-color: ${({ theme, $isDisabled }) => {
      if ($isDisabled) {
        return undefined;
      }

      return theme.newUI.variationColors.light6;
    }};
  }
`;
